import { render, staticRenderFns } from "./OrderPlan.vue?vue&type=template&id=74cfdb72&scoped=true&"
import script from "./OrderPlan.vue?vue&type=script&lang=js&"
export * from "./OrderPlan.vue?vue&type=script&lang=js&"
import style0 from "./OrderPlan.vue?vue&type=style&index=0&id=74cfdb72&scoped=true&lang=css&"
import style1 from "./OrderPlan.vue?vue&type=style&index=1&id=74cfdb72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74cfdb72",
  null
  
)

export default component.exports
import QForm from 'quasar/src/components/form/QForm.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QTr from 'quasar/src/components/table/QTr.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QForm,QSelect,QInput,QBtn,QTable,QTd,QTr});
